import { formatRelationshipDates } from '@entangled-vega/shared';

import type { GraphRelationship } from '../data/graph-types.js';

export function relationshipDateLabel(
  relationship: Pick<GraphRelationship, 'start' | 'end' | 'fixtureDateText'>,
  snapshotDate: string,
): string | null {
  if (relationship.fixtureDateText !== undefined) {
    return relationship.fixtureDateText.replace(/\s+\u00b7\s+data snapshot.+$/u, '');
  }
  if (relationship.start === undefined && relationship.end === undefined) {
    return null;
  }
  return formatRelationshipDates({
    start: relationship.start,
    end: relationship.end,
    snapshotDate,
    includeSnapshotForOpenEnd: false,
  });
}
